export default __webpack_public_path__ + "static/partner-tube-2-105774d447a38a8102a603ee7f16c668.png";